var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-pago'),_vm._v(" "),_c('status',{attrs:{"img":(_vm.$S3 + "checked-1.svg"),"text-one":"FUE REALIZADO","text-two":"CON ÉXITO"}}),_vm._v(" "),_c('section-help'),_vm._v(" "),_c('footer-pago')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd399bf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-pago-exitoso.vue
// module id = 641
// module chunks = 4